import { getInvoice, makePayment } from "helpers/backend_helper"
import { call, put, takeEvery } from "redux-saga/effects"
import { getInvoiceFail, getInvoiceSuccess, makePaymentFail, makePaymentSuccess } from "./actions"
import { GET_INVOICE, MAKE_PAYMENT } from "./actionTypes"
import { isEmpty } from "lodash"

function* getInvoiceSaga() {
    try {
        localStorage.setItem("PaymentState", "Inititated");
        console.log("payment status getInvoiceSaga")
        const response = yield call(getInvoice)
        yield put(getInvoiceSuccess(response))
    } catch (error) {
        if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
            yield put(getInvoiceFail(error.response.data))
        } else {
            yield put(getInvoiceFail(error.message))
        }
    }
}

function* makePaymentSaga() {
    try {
        console.log("payment status makePaymentSaga")
        localStorage.setItem("PaymentState", "Inititated");
        const response = yield call(makePayment)
        yield put(makePaymentSuccess(response))
    } catch (error) {
        if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
            yield put(makePaymentFail(error.response.data))
        } else {
            yield put(makePaymentFail(error.message))
        }
    }
}

function* paymentsSaga() {
    yield takeEvery(GET_INVOICE, getInvoiceSaga)
    yield takeEvery(MAKE_PAYMENT, makePaymentSaga)
}

export default paymentsSaga